module.exports = __webpack_public_path__ + "static/xikunz2-24807a762cb45f965a45533d683a06b0.jpg";